import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/svg/logo.svg'


const _hoisted_1 = { class: "h-screen flex flex-col justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("a", {
  href: "https://imagesuggest.com/",
  class: "mb-10 -mt-10"
}, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = { class: "text-30 font-semibold" }
const _hoisted_4 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseAlertMessage = _resolveComponent("BaseAlertMessage")
  const _component_ResetPasswordRequestForm = _resolveComponent("ResetPasswordRequestForm")
  const _component_BaseCard = _resolveComponent("BaseCard")
  const _component_BaseButton = _resolveComponent("BaseButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_BaseInformation = _resolveComponent("BaseInformation")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isRequestSent)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createVNode(_component_BaseCard, { class: "px-10 md:px-20 w-5/6 md:w-3/5 lg:w-2/5 xl:max-w-screen-md py-11 text-center" }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('forms.reset-request.modal-title')), 1),
              _createVNode(_component_BaseAlertMessage, {
                modelValue: _ctx.isError,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isError = $event)),
                class: "text-left text-10",
                variant: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('errors.password_reset_request_error')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ResetPasswordRequestForm, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event)),
                loading: _ctx.isLoading,
                onSubmit: _ctx.onSubmit
              }, null, 8, ["modelValue", "loading", "onSubmit"])
            ]),
            _: 1
          })
        ], 64))
      : (_openBlock(), _createBlock(_component_BaseInformation, {
          key: 1,
          variant: "success",
          title: _ctx.$t('info-modal.reset-request.title')
        }, {
          text: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('info-modal.reset-request.message-start')), 1),
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.email), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('info-modal.reset-request.message-end')), 1)
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_router_link, { to: { name: 'sign-in' } }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, { class: "w-72" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('actions.sign-in')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"]))
  ]))
}